module.exports = __webpack_public_path__ + "img/EU.536d73d2.svg";